const toggleCancelledDialog = (SystemData, handleUpdate, extraKeys) => {
  const dialog = (e, rowData) => {
    SystemData.confirm(
      rowData.cancelled?"Restore Trip":"Cancel Trip",
      rowData.cancelled?`Are you sure you wish to Restore the Scheduled Trip`:`Are you sure you wish to Cancel the Scheduled Trip`,
      [
        {icon: "check_circle", value: true, label: "Yes", options: {color:"primary"}}, 
        {icon: "cancel", value: false, label: "No", options: {color:"secondary"}}
      ],
      (response) => {
        if (response) {
          handleUpdate.mutate({
            extraKeys,
            record: {...rowData, cancelled: !rowData.cancelled}, 
            oldRecord: rowData,
            postError: (data) => {
              if (data.errorMessage) {
                SystemData.alert("Error", `${data.errorMessage}`);
              } else {
                SystemData.alert("Error", `An Unexpected Error has occurred changing the trips cancellation status.`);
              }
            }
          })
        }
      }
    );
  }
  return dialog;
}

export default toggleCancelledDialog;